/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

export const Production = "Production";

export const Activity = {
    RequestCompleted: "RequestCompleted",
  };

export const SurveyTaken = "Survey submitted";

export const SurveyLaunchFailed = "Survey failed to launch";